<script setup>
import {useMatchedBetStore} from "@/stores/MatchedBetStore";
import {computed} from "vue";

const matchedBetStore = useMatchedBetStore();

const results = computed(() => matchedBetStore.getResults(matchedBetStore.backBetData, matchedBetStore.layBetData));

const formatValue = (value) => {
  const isPositive = value >= 0;
  return {
    text: `${isPositive ? '+' : '-'}£${Math.abs(value).toFixed(2)}`,
    class: isPositive ? 'text-green' : 'text-red',
  };
};
</script>

<template>
  <div class="matched-bet-results-container">
    <table class="bet-table large-screen-table">
      <thead>
      <tr>
        <th></th>
        <th>Back Bet</th>
        <th v-if="matchedBetStore.backBetData.type==='rf'">Cashback Value</th>
        <th>Lay Bet</th>
        <th>Total</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>If back bet wins</td>
        <td :class="formatValue(results.backWin).class">{{ formatValue(results.backWin).text }}</td>
        <td v-if="matchedBetStore.backBetData.type==='rf'" class="text-green">£0</td>
        <td :class="formatValue(results.layLoss).class">{{ formatValue(results.layLoss).text }}</td>
        <td :class="formatValue(results.totalBackWin).class">{{ formatValue(results.totalBackWin).text }}</td>
      </tr>
      <tr>
        <td>If lay bet wins</td>
        <td :class="formatValue(results.backLoss).class">{{ formatValue(results.backLoss).text }}</td>
        <td v-if="matchedBetStore.backBetData.type==='rf'" :class="formatValue(results.backCashback).class">
          {{ formatValue(results.backCashback).text }}
        </td>
        <td :class="formatValue(results.layWin).class">{{ formatValue(results.layWin).text }}</td>
        <td :class="formatValue(results.totalLayWin).class">{{ formatValue(results.totalLayWin).text }}</td>
      </tr>
      </tbody>
    </table>

    <table class="bet-table small-screen-table">
      <thead>
      <tr>
        <th></th>
        <th>If back bet wins</th>
        <th>If lay bet wins</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>Back Bet</td>
        <td :class="formatValue(results.backWin).class">{{ formatValue(results.backWin).text }}</td>
        <td :class="formatValue(results.backLoss).class">{{ formatValue(results.backLoss).text }}</td>
      </tr>
      <tr v-if="matchedBetStore.backBetData.type==='rf'">
        <td>Cashback Value</td>
        <td class="text-green">£0</td>
        <td :class="formatValue(results.backCashback).class">{{ formatValue(results.backCashback).text }}</td>
      </tr>
      <tr>
        <td>Lay Bet</td>
        <td :class="formatValue(results.layLoss).class">{{ formatValue(results.layLoss).text }}</td>
        <td :class="formatValue(results.layWin).class">{{ formatValue(results.layWin).text }}</td>
      </tr>
      <tr>
        <td>Total</td>
        <td :class="formatValue(results.totalBackWin).class">{{ formatValue(results.totalBackWin).text }}</td>
        <td :class="formatValue(results.totalLayWin).class">{{ formatValue(results.totalLayWin).text }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>

.matched-bet-results-container {
  margin-top: 0.5rem;
  background-color: var(--clr-black-10);
  padding: 1rem;

}

.text-green {
  color: green;
}

.text-red {
  color: red;
}

.bet-table {
  width: 100%;
  margin-bottom: 1rem;
}

.bet-table th, .bet-table td {
  padding: 0.75rem;
  text-align: left;
  border: 1px solid #ddd;
}

.bet-table th:first-child,
.bet-table td:first-child {
  border-left: none;
}

.bet-table th {
  border-top: none;
}


.bet-table th:last-child,
.bet-table td:last-child {
  border-right: none;
}

.bet-table tbody tr:last-child td {
  border-bottom: none;
}

.bet-table th {
  font-weight: var(--fw-semi-bold);
}

.bet-table td:first-child {
  font-weight: var(--fw-semi-bold);
}

.large-screen-table {
  display: table;
}

.small-screen-table {
  display: none;
}

@media (max-width: 768px) {
  .large-screen-table {
    display: none;
  }

  .small-screen-table {
    display: table;
  }

  .small-screen-table thead tr {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }

  .small-screen-table tbody {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }

  .small-screen-table tbody tr {
    display: contents;
  }

  .small-screen-table tbody td {
    display: grid;
    align-items: center;
  }

}
</style>

